export const useSxStyles = () => {
  return {
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75em',
    },
  };
};
